import styled from 'styled-components';

type Corner = 'tl' | 'tr' | 'bl' | 'br';

// Corner-snapped and narrow so it covers as little of the UI as possible while
// options are being compared; the corner control moves it off anything it hides.
export const Base = styled.div<{ $corner: Corner }>`
	position: fixed;
	${({ $corner }) => ($corner === 'tl' || $corner === 'tr' ? 'top: 12px;' : 'bottom: 12px;')}
	${({ $corner }) => ($corner === 'tl' || $corner === 'bl' ? 'left: 12px;' : 'right: 12px;')}
	z-index: 9999;
	width: 232px;
	padding: 6px;
	border-radius: 8px;
	background-color: ${({ theme }) => theme.gray[0]};
	border: 1px solid ${({ theme }) => theme.gray[400]};
	box-shadow: 0 4px 16px rgba(0, 0, 0, 0.18);
	font-size: 11px;
	color: ${({ theme }) => theme.gray[1000]};
	user-select: none;
`;

export const Header = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 2px 4px 4px 4px;
`;

export const Title = styled.div`
	font-weight: 600;
	letter-spacing: 0.02em;
	text-transform: uppercase;
	font-size: 10px;
	color: ${({ theme }) => theme.gray[700]};
`;

export const Controls = styled.div`
	display: flex;
	gap: 2px;
`;

export const Control = styled.button`
	width: 16px;
	height: 16px;
	padding: 0;
	display: flex;
	align-items: center;
	justify-content: center;
	border: none;
	border-radius: 4px;
	background-color: transparent;
	font-size: 12px;
	color: ${({ theme }) => theme.gray[900]};

	&:hover {
		background-color: ${({ theme }) => theme.gray[200]};
	}
`;

export const Row = styled.div`
	display: flex;
	align-items: center;
	gap: 6px;
	padding: 3px 4px;
`;

export const Label = styled.div`
	width: 52px;
	flex-shrink: 0;
	color: ${({ theme }) => theme.gray[700]};
`;

export const Values = styled.div`
	display: flex;
	gap: 2px;
	flex-shrink: 0;
`;

export const Value = styled.button<{ $active: boolean }>`
	width: 18px;
	height: 18px;
	padding: 0;
	border-radius: 4px;
	font-size: 11px;
	font-weight: 600;
	border: 1px solid ${({ $active, theme }) => ($active ? theme.blue[500] : theme.gray[400])};
	background-color: ${({ $active, theme }) => ($active ? theme.blue[500] : 'transparent')};
	color: ${({ $active, theme }) => ($active ? '#ffffff' : theme.gray[900])};

	&:hover {
		border-color: ${({ theme }) => theme.blue[500]};
	}
`;

export const Current = styled.div`
	flex: 1;
	min-width: 0;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	color: ${({ theme }) => theme.gray[600]};
`;
